export const GRAPH_TABS = [
    { key: "correctness", label: "CORRECTNESS RATE" },
    { key: "accuracyandprecision", label: "ACCURACY AND PRECISION" },
    { key: "precision", label: "PRECISION" },
    { key: "level", label: "LEVEL" },
    { key: "activity", label: "ACTIVITY CHART" },
]
